import { render, staticRenderFns } from "./RetentionCheck.vue?vue&type=template&id=01fbb8ea&"
import script from "./RetentionCheck.vue?vue&type=script&lang=js&"
export * from "./RetentionCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports